import { ShopifyProduct } from "../types";

import { loadProducts } from "./loadProducts";

interface UpdateProductsOptions<T extends { id: string }> {
  existing: T[];
  productIds: string[];
  create: (product: ShopifyProduct) => T;
}

export async function updateProducts<T extends { id: string }>(
  options: UpdateProductsOptions<T>
) {
  const existing = options.existing.reduce(
    (map, item: T) => {
      map[item.id] = item;
      return map;
    },
    {} as Record<string, T>
  );

  const productsToLoad = options.productIds.filter((id) => !existing[id]);
  const products = await loadProducts(productsToLoad);
  const productsMap = new Map(products.map((p) => [p.id, p]));

  const result: T[] = [];
  for (const id of options.productIds) {
    let item: T | undefined = existing[id];
    if (item === undefined) {
      const product = productsMap.get(id);
      if (product !== undefined) {
        item = options.create(product);
      }
    }
    if (item !== undefined) {
      result.push(item);
    }
  }
  return result;
}
